import { Vue, Watch, Prop } from "vue-property-decorator";
import { ShowcasePageData } from "fs-pb-vue2/data/showcasePageData";
import { ShowcaseCreditData} from "fs-pb-vue2/data/showcaseCreditData";
import { ShowcaseInsurance } from "fs-pb-vue2/data/showcaseInsurance";
import { ShowCaseActionType } from "fs-pb-vue2/data/enums/showCaseActionType";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { container } from "@/inversify.config";
import { PersonStore } from "fs-pb-vue2/store/modules/person";
import { getModule } from "vuex-module-decorators";
import { Dictionary } from "vue-router/types/router";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";

export class ShowCaseCreditsListVueGB extends Vue {

  // porps:

  @Prop() pageObj!: ShowcasePageData;

  @Prop() creditsList!: Array<ShowcasePageData>;

  // data:
  
  listLoading: boolean = false;

  calcLoading: boolean = false;

  hasError: boolean = false;

  stateIsActual: boolean = false;

  blockContinue: boolean = true;

  // Данные для модального окна
  isModalOpen: boolean = false;
  modalTitle: string = '';
  showModalButtons: boolean = false;
  selectedContractId: number | null = null;

  handleYes: () => void;
  handleNo: () => void;

  isApproved: any = null;

  credits: Array<ShowcaseCreditData> = [];

  insurances: Array<ShowcaseInsurance> = [];
  //Insurances: Array<ShowcaseInsurance> = [];
  
  creditForCalc: ShowcaseCreditData = null;

  calcSum: string = '0';

  calcPeriod: number = 0;

  calcInsurance: boolean[] = [];

  selectedInsuranceIndex: number | null = null;

  calculatedResult: any = {};

  calculated: any = {
    sum: 0,
    percent: 0,
    draft: 0
  }

  // computed

  /**
   * Сервис уведомлений
   * @returns {IAlertService}
   */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get validateCalc(): boolean {
    const someDec: number = +this.calcSum.replaceAll(' ', '');
    if (someDec < this.creditForCalc.CalcView.SumFrom || someDec > this.creditForCalc.CalcView.SumTo)
      return false;
    if (this.calcPeriod < this.creditForCalc.CalcView.PeriodFrom || this.calcPeriod > this.creditForCalc.CalcView.PeriodTo)
      return false;
    return true;
  }

  get sumRules(): any {
    const someDec: number = +this.calcSum.replaceAll(' ', '');
    return (someDec >= this.creditForCalc.CalcView.SumFrom && someDec <= this.creditForCalc.CalcView.SumTo) 
      || `от ${this.creditForCalc.CalcView.SumFrom.toLocaleString('ru')} до ${this.creditForCalc.CalcView.SumTo.toLocaleString('ru')}`
  }

  get periodRules(): any {
    return (this.calcPeriod >= this.creditForCalc.CalcView.PeriodFrom && this.calcPeriod <= this.creditForCalc.CalcView.PeriodTo) 
      || `от ${this.creditForCalc.CalcView.PeriodFrom.toLocaleString('ru')} до ${this.creditForCalc.CalcView.PeriodTo.toLocaleString('ru')}`
  }

  get canContinue(): boolean {
    return !this.hasError && this.stateIsActual;
  }

  get filteredCredits(): ShowcaseCreditData[] {
    const pageId = this.$route.params.pageId;
    if (!pageId)
      return [];
    return this.credits.filter((credit: ShowcaseCreditData) => credit.Id.toString() === pageId);
  }

  // methods:

  init(): void {
    const calcData = this.pageObj.Data.calc;
    this.creditForCalc = null;
    this.credits = [];
    if (this.pageObj.Data.list && this.pageObj.Data.list.length && this.creditsList.length) {
      this.pageObj.Data.list.map((item: any) => {
        if (item) {
          const creditItem: ShowcasePageData = this.creditsList.find((credit: ShowcasePageData) => item.actionLink.includes(credit.Id));
          if (creditItem) {
            this.credits.push(new ShowcaseCreditData(item, creditItem));
          }
        }
      })
    } else if (this.creditsList.length && this.$route.params.pageId !== 'calc') {
      this.creditsList.map((item: ShowcasePageData) => {
        if (item) {
          this.credits.push(new ShowcaseCreditData({
            image: item.Data.view.imageWeb,
            caption: item.Caption,
            actionType: 'OpenLinkInApp',
            actionLink: `showcase/calc?id=${item.Id}`
          }, item));
        }
      })
    } else if (calcData) {
      this.creditForCalc = new ShowcaseCreditData({}, this.pageObj);
      this.calcSum = this.creditForCalc.CalcView.DefaultSum.toLocaleString('ru');
      this.calcPeriod = this.creditForCalc.CalcView.DefaultPeriod;

      if (calcData.insuranceCaption.length) {

        if (calcData.insurances && calcData.insurances.length)
          this.insurances = calcData.insurances.map((ins: any) => new ShowcaseInsurance(ins));

        const calcInsuranceData: any = {
            insuranceCaption: calcData.insuranceCaption,
            insuranceDetail: calcData.insuranceDetail,
            actionType: calcData.actionType,
            actionLink: calcData.actionLink,
            description: calcData.description,
            falseInsuranceTumblerDescription: calcData.falseInsuranceTumblerDescription
        };
        this.insurances.unshift(new ShowcaseInsurance(calcInsuranceData));
      }
    }
  }

  callAction(credit: any): void {
    if (credit) {
      switch (credit.ActionType) {
        case ShowCaseActionType.Close:
          console.log('Close action');
          break;
        case ShowCaseActionType.OpenLinkInApp:
          this.$router.push(`/${credit.ActionLink}`)
          break;
        case ShowCaseActionType.OpenLinkInBrowser:
          window.open(this.$options.filters.url(credit.ActionLink), '_blank');
          break;
        case ShowCaseActionType.DownloadFile: {
          const link = document.createElement("a");
          link.href = this.$options.filters.url(credit.ActionLink);
          link.download = credit.ActionLink.substring(credit.ActionLink.lastIndexOf('/'));
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          break;
        }
        default:
          console.log('None action');
          break;
      }
    }

    sessionStorage.removeItem('calcCreditData');
  }

  callDetailAction(credit: ShowcaseCreditData): void {
    if (credit) {
      this.callAction(credit.CreditView);
    }
  }

  callDetailCalcAction(credit: ShowcaseCreditData): void {
    if (credit) {
      this.callAction(credit.CalcView);
    }
  }

  caclNext(): void {

    if (this.creditForCalc.RespondentCodeRequest == '0')
      return;

    const regAddress: string = this.personStore.personInfo.Data.RegAddress;
    const email: string = this.personStore.personInfo.Data.EMail;
    let query: string = `/operation/0/${this.creditForCalc.RespondentCodeRequest}?`;
    
    const addInitData: any = 
    {
      'сreditRequest': 'true',
      'sum': this.calcSum.replaceAll(' ', '').replaceAll(',', '.'),
      'period': this.calcPeriod.toString(),
      'finInsuranceEnable': this.calcInsurance.includes(true) ? '1' : '0',
      'registrationAddress': regAddress,
      'email': email,
      'periodFrom': this.creditForCalc.CalcView.PeriodFrom.toString(),
      'periodTo': this.creditForCalc.CalcView.PeriodTo.toString(),
      'sumFrom': this.creditForCalc.CalcView.SumFrom.toString(),
      'sumTo': this.creditForCalc.CalcView.SumTo.toString(),
      'creditSum': this.calculated.sum,
      "creditDraft": this.calculated.draft,
      "creditPerc": this.calculated.percent,
      "creditType": this.creditForCalc.CreditType
    };

    if(this.selectedInsuranceIndex !== null && this.calcInsurance.includes(true)) {
      addInitData["finInsuranceCaption"] = this.insurances[this.selectedInsuranceIndex]?.InsuranceCaption;
    }

    for (const key in addInitData) {
      query += `${key}=${addInitData[key]}&`;
    }

    this.$router.push(query);

    sessionStorage.setItem('calcCreditData', JSON.stringify(addInitData));
  }

  async calculateCredit(): Promise<void> {
    this.calcLoading = true;

    const storedData = sessionStorage.getItem('calcCreditData');
    if (storedData) {
      const initData = JSON.parse(storedData);
      this.calcSum = initData.sum;
      this.calcPeriod = initData.period;
      this.calcInsurance = [initData.finInsuranceEnable === '1'];

      sessionStorage.removeItem('calcCreditData');
    }

    if (!this.validateCalc) {
      this.calcSum = +this.calcSum.replaceAll(' ', '') < this.creditForCalc.CalcView.SumFrom ? 
        this.creditForCalc.CalcView.SumFrom.toLocaleString() : 
        +this.calcSum.replaceAll(' ', '') > this.creditForCalc.CalcView.SumTo ? this.creditForCalc.CalcView.SumTo.toLocaleString() : this.calcSum;
      this.calcPeriod = this.calcPeriod < this.creditForCalc.CalcView.PeriodFrom ? 
        this.creditForCalc.CalcView.PeriodFrom :
        +this.calcPeriod > this.creditForCalc.CalcView.PeriodTo ? this.creditForCalc.CalcView.PeriodTo : this.calcPeriod;
      await this.calculateCredit();
      this.calcLoading = false;
      return;
    }

    try {
      let ord: OperationRequestData = new OperationRequestData();
      ord.respondentCode = this.creditForCalc.RespondentCode;
      const someDec: string = this.calcSum.replaceAll(' ', '');
      ord.setProperty('sum', someDec, DeclarationPropertiesTypes.Decimal);
      ord.setProperty('period', this.calcPeriod, DeclarationPropertiesTypes.Int);
      const insuranceSelected = this.calcInsurance.includes(true);
      ord.setProperty('insurance', insuranceSelected.toString(), DeclarationPropertiesTypes.Boolean);

      if (this.selectedInsuranceIndex !== null && this.insurances[this.selectedInsuranceIndex] && insuranceSelected) {
        const selectedInsurance = this.insurances[this.selectedInsuranceIndex];
        ord.setProperty('insuranceCaption', selectedInsurance.InsuranceCaption, DeclarationPropertiesTypes.String);
      }

      ord.setProperty('creditType', this.creditForCalc.CreditType, DeclarationPropertiesTypes.String);

      if (this.isApproved != null) {
        ord.setProperty("isAproved", this.isApproved, DeclarationPropertiesTypes.Boolean);
      }

      ord = await OperationsApi.executeOperationSendAsync(ord);

      if (!ord || ord.message) {
        this.hasError = true;
        this.alertService.error(ord.message);
      } else  {
        this.blockContinue = this.canContinue;
        const index = ord.keys.indexOf("isAproved")
        if (index !== -1) {
          const isAprovedValue = ord.values[index].toLowerCase();
          this.isApproved = isAprovedValue.toLowerCase() === 'true' || isAprovedValue === '1';
        }

        let referenceId: any = null;
        const referenceIndex = ord.keys.indexOf("existingRequest")
        if (referenceIndex !== -1) {
          referenceId = ord.values[referenceIndex];
          if(referenceId) {
            const contracts = await await ContractsApi.getAllContractsAsync();
            const contract = contracts.find(c => c.ReferenceId === referenceId);
            if(contract) {
              this.selectedContractId = contract.Id;
              this.openModal("Вы уже отправили заявку. Перейти к ней?", true, contract.Id);
            }
          } else {
            this.openModal("У Вас уже есть кредитная заявка в процессе оформления");
          }
          this.stateIsActual = true;
        }

        this.calculated.sum = ord.getPropertyValue('creditSum');
        this.calculated.percent = ord.getPropertyValue('creditPerc');
        this.calculated.draft = ord.getPropertyValue('creditDraft');
        this.calcSum = ord.getPropertyValue('sum');
      }

    } catch (e: any) {
      this.hasError = true;
      this.alertService.error(e.message);
    }

    this.calcSum = isNaN(+this.calcSum) ? this.calcSum : (+this.calcSum).toLocaleString('ru');
    this.calcLoading = false;
  }

  // Методы для управления модальным окном
  openModal(title: string, showButtons: boolean = false, contractId: number | null = null) {
    this.modalTitle = title;
    this.showModalButtons = showButtons;
    this.selectedContractId = contractId;
    this.isModalOpen = true;

    this.handleYes = () => {
      this.closeModal();
      if (this.selectedContractId) {
        this.$router.push({ name: 'Credit', params: { contractId: this.selectedContractId.toString() } });
      }
    };
    this.handleNo = () => {
      this.closeModal();
      this.$router.go(-1);
    };
  }

  closeModal() {
    this.isModalOpen = false;
  }
}
